import React, { useEffect, useState } from "react";
import OrderFormModal from "./oderForm.js";
import thongTinSanPham from "../assets/thongtinsanpham.png";
import gift1 from "../assets/informationGift1.png";
import bangSize from "../assets/bangsize.png";
import iconButton from "../assets/Vector.png";
import "react-image-lightbox/style.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import gift2 from "../assets/Frame 2147223336.png";
import gift3 from "../assets/Frame 2147223337.png";
import gift4 from "../assets/Frame 2147223338.png";
import gift5 from "../assets/Frame 2147223339.png";
import title from "../assets/COMBO ÁO POLO + MŨ BẢO HIỂM.png";
import imageSize from "../assets/imageSize.png";

const GiftDetailModal1 = ({ isOpen, closeModal }) => {
  const [isOpenImageModal, setIsOpenImageModal] = useState(false); // Trạng thái modal ảnh phóng to
  const [currentImage, setCurrentImage] = useState(null); // Trạng thái ảnh hiện tại
  const [isOderFormModalOpen, setIsOderFormModalOpen] = useState(false);
  const [size, setSize] = useState(false);
  const [gender, setGender] = useState(false);
  const [isShowSize, setIsShowSize] = useState(true);

  useEffect(() => {
    if (isOpen) {
      setSize(false);
      setGender(false);
    }
  }, [isOpen]);
  // Hàm mở ảnh phóng to
  const openImageModal = (image) => {
    setCurrentImage(image);
    setIsOpenImageModal(true);
  };

  // Hàm đóng modal phóng to
  const closeImageModal = () => {
    setIsOpenImageModal(false);
  };
  const openOderFormModal = () => {
    if (!size && !gender) {
      toast.error(
        "Quý khách vui lòng chọn mẫu áo và size áo phù hợp trước khi đặt hàng."
      );
      return;
    }

    if (!size) {
      toast.error(
        "Quý khách vui lòng chọn size áo phù hợp trước khi đặt hàng."
      );
      return;
    }

    if (!gender) {
      toast.error("Quý khách vui lòng chọn mẫu áo phù hợp trước khi đặt hàng.");
      return;
    }

    // Nếu mọi thứ đã chọn đầy đủ
    setIsOderFormModalOpen(true);
  };
  const closeOderFormModal = () => setIsOderFormModalOpen(false);
  if (!isOpen) return null;
  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-50 z-20 flex items-center justify-center">
        <div className="relative bg-white p-8 rounded-lg w-[1100px] h-[870px] max-w-[1400px] max-h-[800px] overflow-auto shadow-lg md:block hidden ">
          <div className="border-b-2 pb-5 mb-5">
            <h5 className="font-bold">THÔNG TIN QUÀ TẶNG </h5>
          </div>

          <div className="flex space-x-4">
            <div className="text-black p-1 h-[500px] w-3/5 flex gap-2">
              <img
                src={gift1}
                alt="chitietqua"
                className="w-[470px] h-full object-cover"
              />
              <div className="flex flex-col gap-2">
                <img src={gift2} alt="" />
                <img src={gift3} alt="" />
                <img src={gift4} alt="" />
                <img src={gift5} alt="" />
              </div>
            </div>
            <div className="p-1 w-2/5">
              <img src={title} alt="" />

              <img
                src={bangSize}
                alt="bangsize"
                className="w-full h-auto object-cover rounded-lg mb-4 cursor-pointer transition-transform duration-300 hover:scale-105 hover:brightness-110"
                onClick={() => openImageModal(bangSize)}
              />

              <div className="flex justify-center gap-2 text-[13px]">
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name="role"
                    value="Nam"
                    className="hidden peer"
                    onClick={() => {
                      setGender("Nam");
                      setIsShowSize(true);
                    }}
                  />
                  <div className="w-[35px] h-[30px] flex items-center justify-center border rounded-lg peer-checked:bg-[url('/public/images/bgButton.png')] peer-checked:text-white  text-blue-600 peer-checked:text-white">
                    Nam
                  </div>
                </label>
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name="role"
                    value="nữ"
                    className="hidden peer"
                    onClick={() => {
                      setGender("Nữ");
                      setIsShowSize(false);
                      size === "NC2" ? setSize("") : setSize(size);
                      size === "NC3" ? setSize("") : setSize(size);
                    }}
                  />
                  <div className="w-[35px] h-[30px] flex items-center justify-center border rounded-lg peer-checked:bg-[url('/public/images/bgButton.png')] peer-checked:text-white  text-blue-600 peer-checked:text-white">
                    Nữ
                  </div>
                </label>
                <p className="text-gray-500">|</p>
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name="size"
                    value="M"
                    className="hidden peer"
                    onClick={() => setSize("M")}
                  />
                  <div className="w-[35px] h-[30px] flex items-center justify-center border rounded-lg peer-checked:bg-[url('/public/images/bgButton.png')] peer-checked:text-white  text-blue-600 peer-checked:text-white">
                    M
                  </div>
                </label>

                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name="size"
                    value="L"
                    onClick={() => setSize("L")}
                    className="hidden peer"
                  />
                  <div className="w-[35px] h-[30px] flex items-center justify-center border rounded-lg peer-checked:bg-[url('/public/images/bgButton.png')] peer-checked:text-white  text-blue-600 peer-checked:text-white">
                    L
                  </div>
                </label>

                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name="size"
                    value="XL"
                    onClick={() => setSize("XL")}
                    className="hidden peer"
                  />
                  <div className="w-[35px] h-[30px] flex items-center justify-center border rounded-lg peer-checked:bg-[url('/public/images/bgButton.png')] peer-checked:text-white  text-blue-600 peer-checked:text-white">
                    XL
                  </div>
                </label>

                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name="size"
                    value="2XL"
                    onClick={() => setSize("2XL")}
                    className="hidden peer"
                  />
                  <div className="w-[35px] h-[30px] flex items-center justify-center border rounded-lg peer-checked:bg-[url('/public/images/bgButton.png')] peer-checked:text-white  text-blue-600 peer-checked:text-white">
                    2XL
                  </div>
                </label>
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name="size"
                    value="NC1"
                    onClick={() => setSize("NC1")}
                    className="hidden peer"
                  />
                  <div className="w-[35px] h-[30px] flex items-center justify-center border rounded-lg peer-checked:bg-[url('/public/images/bgButton.png')] peer-checked:text-white  text-blue-600 peer-checked:text-white">
                    NC1
                  </div>
                </label>
                {isShowSize && (
                  <div className="flex gap-2">
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input
                        type="radio"
                        name="size"
                        value="NC3"
                        onClick={() => setSize("NC3")}
                        className="hidden peer"
                      />
                      <div className="w-[35px] h-[30px] flex items-center justify-center border rounded-lg peer-checked:bg-[url('/public/images/bgButton.png')] peer-checked:text-white  text-blue-600 peer-checked:text-white">
                        NC2
                      </div>
                    </label>
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input
                        type="radio"
                        name="size"
                        value="NC3"
                        onClick={() => setSize("NC3")}
                        className="hidden peer"
                      />
                      <div className="w-[35px] h-[30px] flex items-center justify-center border rounded-lg peer-checked:bg-[url('/public/images/bgButton.png')] peer-checked:text-white  text-blue-600 peer-checked:text-white">
                        NC3
                      </div>
                    </label>
                  </div>
                )}
              </div>
              <button
                onClick={openOderFormModal}
                className="relative mx-auto bg-blue-500 flex gap-3 items-center text-white px-10 py-2 rounded-l-full m-10 rounded-r-full"
                style={{
                  backgroundImage: `url(/images/bgButton.png)`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                <img src={iconButton} alt="icon" />
                ĐĂNG KÝ NHẬN
              </button>
            </div>
          </div>
          <p className="text-[13px] font-semibold my-3">
            Tất cả các thành viên của RR88 có tổng giao dịch nạp tiền trong
            tháng từ 1,000 điểm trở lên, bấm vào mục ĐĂNG KÝ TẠI ĐÂY và điền đầy
            đủ thông tin nhận quà sẽ nhận được phần thưởng Combo Áo Polo và mũ
            bảo hiểm chất lượng cao. Ngoài ra hệ thống còn rất nhiều phần quà
            tri ân và khuyến mãi HOT đang chờ đón bạn! <br /> <br />
            Áo Polo RR88 là một dòng sản phẩm áo polo được RR88 nghiên cứu kỹ và
            thiết kế đề cao tính thoải mái, dễ chịu và dễ phối đồ. Chất liệu và
            công nghệ làm mát được ứng dụng giúp áo hạn chế tích tụ nhiệt, làm
            khô nhanh chóng mang đến 1 trải nghiệm hoàn hảo mỗi khi diện đồ.
            <br /> <br />
            Đặc biệt hơn: Thấu hiểu và quan tâm sự an toàn của quý khách hàng
            khi tham gia giao thông, mũ bảo hiểm chất lượng cao giúp bạn an tâm,
            vững tay trên mọi nẻo đường và hạn chế chấn thương trong trường hợp
            không may.
          </p>
          <div className="flex justify-end mt-5">
            <img src={imageSize} alt="" />
          </div>
          <button
            onClick={closeModal}
            className="absolute top-4 right-4 text-black bg-gray-200 rounded-full p-2 hover:bg-gray-300"
          >
            ✕
          </button>
        </div>
        {/* mobile */}
        <div className="relative bg-[#EFF6FF]   mx-3 p-3 rounded-lg w-[400px] h-[91%] top-[33px]   max-w-[1400px] overflow-auto shadow-lg md:hidden block responsive_mobile">
          <div className="border-b-2 pb-3 mb-2">
            <h5 className="font-bold">THÔNG TIN QUÀ TẶNG </h5>
          </div>
          <div className="w-full mx-auto bg-gray-100">
            <div className="flex flex-col gap-3">
              {/* Chi tiết quà tặng */}
              <div className="text-black p-1 w-full">
                <img src={title} alt="" className="w-[250px] mb-5" />

                <div className="text-black p-1 flex gap-2">
                  <img
                    src={gift1}
                    alt="chitietqua"
                    className="w-[80%] h-full object-cover"
                  />
                  <div className="flex flex-col gap-2">
                    <img src={gift2} alt="" />
                    <img src={gift3} alt="" />
                    <img src={gift4} alt="" />
                    <img src={gift5} alt="" />
                  </div>
                </div>
              </div>
              <button
                onClick={openOderFormModal}
                className=" bg-blue-500 text-white px-10 flex py-2 rounded-l-full rounded-r-full hover:bg-blue-600 mx-auto gap-1"
                style={{
                  backgroundImage: `url(/images/bgButton.png)`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                <img src={iconButton} alt="icon" />
                ĐĂNG KÝ NHẬN
              </button>
              <div className="flex justify-start gap-1 text-[12px] !text-[#2B8DFE] font-bold">
                <label className="flex items-center cursor-pointer">
                  <input
                    type="radio"
                    name="role"
                    value="Nam"
                    className="hidden peer"
                    onClick={() => setGender("Nam")}
                  />
                  <div
                    className="w-[42px] h-[30px] flex items-center justify-center border rounded-lg peer-checked:bg-[url('/public/images/bgButton.png')] peer-checked:text-white  peer-checked:text-white"
                    onClick={() => setIsShowSize(true)}
                  >
                    Nam
                  </div>
                </label>
                <label className="flex items-center cursor-pointer">
                  <input
                    type="radio"
                    name="role"
                    value="nữ"
                    className="hidden peer"
                    onClick={() => {
                      setGender("Nữ");
                    }}
                  />
                  <div
                    className="w-[42px] h-[30px] flex items-center justify-center border rounded-lg peer-checked:bg-[url('/public/images/bgButton.png')] peer-checked:text-white peer-checked:text-white"
                    onClick={() => {
                      setIsShowSize(false);
                    }}
                  >
                    Nữ
                  </div>
                </label>
                <label className="flex items-center gap-2 cursor-pointer ml-6">
                  <input
                    type="radio"
                    name="size"
                    value="M"
                    className="hidden peer"
                    onClick={() => setSize("M")}
                  />
                  <div className="w-[30px] h-[28px] flex items-center justify-center border rounded-lg peer-checked:bg-[url('/public/images/bgButton.png')] peer-checked:text-white peer-checked:text-white">
                    M
                  </div>
                </label>

                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name="size"
                    value="L"
                    onClick={() => setSize("L")}
                    className="hidden peer"
                  />
                  <div className="w-[30px] h-[28px] flex items-center justify-center border rounded-lg peer-checked:bg-[url('/public/images/bgButton.png')] peer-checked:text-white peer-checked:text-white">
                    L
                  </div>
                </label>

                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name="size"
                    value="XL"
                    onClick={() => setSize("XL")}
                    className="hidden peer"
                  />
                  <div className="w-[30px] h-[28px] flex items-center justify-center border rounded-lg peer-checked:bg-[url('/public/images/bgButton.png')] peer-checked:text-white peer-checked:text-white">
                    XL
                  </div>
                </label>

                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name="size"
                    value="2XL"
                    onClick={() => setSize("2XL")}
                    className="hidden peer"
                  />
                  <div className="w-[30px] h-[28px] flex items-center justify-center border rounded-lg peer-checked:bg-[url('/public/images/bgButton.png')] peer-checked:text-white peer-checked:text-white">
                    2XL
                  </div>
                </label>
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name="size"
                    value="NC1"
                    onClick={() => setSize("NC1")}
                    className="hidden peer"
                  />
                  <div className="w-[30px] h-[28px] flex items-center justify-center border rounded-lg peer-checked:bg-[url('/public/images/bgButton.png')] peer-checked:text-white  peer-checked:text-white">
                    NC1
                  </div>
                </label>
                {isShowSize && (
                  <div className="flex gap-1">
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input
                        type="radio"
                        name="size"
                        value="NC2"
                        onClick={() => setSize("NC2")}
                        className="hidden peer"
                      />
                      <div className="w-[30px] h-[28px] flex items-center justify-center border rounded-lg peer-checked:bg-[url('/public/images/bgButton.png')] peer-checked:text-white  peer-checked:text-white">
                        NC2
                      </div>
                    </label>{" "}
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input
                        type="radio"
                        name="size"
                        value="NC3"
                        onClick={() => setSize("NC3")}
                        className="hidden peer"
                      />
                      <div className="w-[30px] h-[28px] flex items-center justify-center border rounded-lg peer-checked:bg-[url('/public/images/bgButton.png')] peer-checked:text-white  peer-checked:text-white">
                        NC3
                      </div>
                    </label>
                  </div>
                )}
              </div>
              <div className="flex justify-start">
                <img src={imageSize} alt="" />
              </div>

              {/* Combo Áo Polo + Mũ bảo hiểm */}
              <div className="p-1 w-full">
                <img
                  src={bangSize}
                  alt="bangsize"
                  className="w-[500px] h-auto object-cover rounded-lg  cursor-pointer transition-transform duration-300 hover:scale-105 hover:brightness-110 mx-auto"
                  onClick={() => openImageModal(bangSize)}
                />

                {/* Chọn kích thước */}

                {/* Đăng ký nhận */}
              </div>
              <div>
                <p className="text-[12px] font-semibold">
                  Tất cả các thành viên của RR88 có tổng giao dịch nạp tiền
                  trong tháng từ 1,000 điểm trở lên, bấm vào mục ĐĂNG KÝ TẠI ĐÂY
                  và điền đầy đủ thông tin nhận quà sẽ nhận được phần thưởng
                  Combo Áo Polo và mũ bảo hiểm chất lượng cao. Ngoài ra hệ thống
                  còn rất nhiều phần quà tri ân và khuyến mãi HOT đang chờ đón
                  bạn! <br /> <br />
                  Áo Polo RR88 là một dòng sản phẩm áo polo được RR88 nghiên cứu
                  kỹ và thiết kế đề cao tính thoải mái, dễ chịu và dễ phối đồ.
                  Chất liệu và công nghệ làm mát được ứng dụng giúp áo hạn chế
                  tích tụ nhiệt, làm khô nhanh chóng mang đến 1 trải nghiệm hoàn
                  hảo mỗi khi diện đồ.
                  <br /> <br />
                  Đặc biệt hơn: Thấu hiểu và quan tâm sự an toàn của quý khách
                  hàng khi tham gia giao thông, mũ bảo hiểm chất lượng cao giúp
                  bạn an tâm, vững tay trên mọi nẻo đường và hạn chế chấn thương
                  trong trường hợp không may.
                </p>
              </div>
            </div>
          </div>
          <button
            onClick={closeModal}
            className="absolute top-4 right-4 text-black bg-gray-200 rounded-full p-2 hover:bg-gray-300"
          >
            ✕
          </button>
        </div>
      </div>

      {isOpenImageModal && (
        <div className="fixed inset-0 bg-black bg-opacity-75 z-30 flex items-center justify-center">
          <div className="relative bg-white p-4 rounded-lg max-w-full max-h-full overflow-auto md:block hidden">
            <img
              src={currentImage}
              alt="Enlarged"
              className="max-w-full max-h-[80vh] object-contain"
            />
            <button
              onClick={closeImageModal}
              className="absolute top-4 right-4 text-white bg-gray-800 rounded-full hover:bg-gray-700"
            >
              ✕
            </button>
          </div>
          {/* mobile */}
          <div className="relative md:hidden block">
            <img
              src={currentImage}
              alt="Enlarged"
              className="w-[500px] h-[310px] object-cover" // Đảm bảo ảnh chiếm toàn bộ chiều rộng và chiều cao của thẻ div
            />
            <button
              onClick={closeImageModal}
              className="absolute top-4 right-4 text-white bg-gray-800 rounded-full hover:bg-gray-700"
            >
              x
            </button>
          </div>
        </div>
      )}
      <ToastContainer />
      <OrderFormModal
        isOpen={isOderFormModalOpen}
        closeModal={closeOderFormModal}
        gender={gender}
        size={size}
        type={1}
        checkPoint={1000}
      />
    </>
  );
};
export default GiftDetailModal1;
